import * as React from "react";

function GlobeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M256 0c141.4 0 256 114.6 256 256S397.4 512 256 512 0 397.4 0 256 114.6 0 256 0zm0 464c7.4 0 26.1-7.2 47.6-48.4 8.8-17.7 15.5-39.2 22-63.6H186.4c5.6 24.4 13.2 45.9 22 63.6C229 456.8 248.6 464 256 464zm-77.5-160h155c1.6-15.3 2.5-31.4 2.5-48s-.9-32.7-2.5-48h-155c-1.6 15.3-2.5 31.4-2.5 48s.9 32.7 2.5 48zm147.1-144c-6.5-24.4-13.2-45.9-22-63.55C282.1 55.22 263.4 48 256 48c-7.4 0-27 7.22-47.6 48.45-8.8 17.65-16.4 39.15-22 63.55h139.2zm56.2 48c1.4 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48h76.6c3.7-15.4 5.6-31.5 5.6-48s-1.9-32.6-5.6-48h-76.6zM342.1 66.61c14.1 25.65 25.3 57.49 32.6 93.39h65.9c-21.4-41.1-56.2-74.12-98.5-93.39zm-172.2 0C127.6 85.88 92.84 118.9 71.43 160h65.87c7.3-35.9 18.5-67.74 32.6-93.39zM48 256c0 16.5 1.93 32.6 5.57 48h76.63c-1.4-15.5-2.2-31.6-2.2-48s.8-32.5 2.2-48H53.57C49.93 223.4 48 239.5 48 256zm392.6 96h-65.9c-7.3 35.9-18.5 67.7-32.6 93.4 42.3-19.3 77.1-52.3 98.5-93.4zm-303.3 0H71.43c21.41 41.1 56.17 74.1 98.47 93.4-14.1-25.7-25.3-57.5-32.6-93.4z"
  }));
}

const ForwardRef = React.forwardRef(GlobeIcon);
export default ForwardRef;